module.exports = __webpack_public_path__ + "static/media/genero.a7e1ee5c.jpg";